export const termsTranslations = {
  title: "Conditions Générales de Vente et d'Utilisation (CGVU)",
  description: "Conditions générales de vente et d'utilisation de Leadsme. Modalités d'accès, d'utilisation et de souscription aux offres proposées.",
  content: `1. Objet
Les présentes Conditions Générales de Vente et d'Utilisation (dites « CGVU ») ont pour objet de définir les conditions dans lesquelles l'éditeur met à disposition le service Leadsme, ainsi que les modalités d'accès, d'utilisation et, le cas échéant, de souscription aux offres proposées.
Le service Leadsme est un outil en ligne de gestion et d'organisation destiné aux créateurs de contenus et professionnels assimilés, incluant notamment des fonctionnalités de gestion de contacts, de projets, de fichiers et de suivi informatif des paiements.

2. Acceptation des CGVU
L'accès et l'utilisation du service impliquent l'acceptation pleine et entière des présentes CGVU.
Cette acceptation est matérialisée :
- soit lors de la création d'un compte,
- soit par l'utilisation effective du service.
Les CGVU constituent un contrat liant l'utilisateur et l'éditeur.

3. Accès au service
Le service est accessible via un compte utilisateur personnel.
L'éditeur met en œuvre des moyens raisonnables pour assurer l'accessibilité du service, sans garantir une disponibilité continue ou exempte d'interruptions.
Des suspensions temporaires peuvent intervenir notamment pour maintenance, mise à jour, incidents techniques ou contraintes externes.
Le service est destiné en priorité aux utilisateurs établis en France, à un usage professionnel, et suppose la capacité juridique à contracter.

4. Création de compte et authentification
La création d'un compte nécessite la fourniture d'informations exactes, complètes et à jour.
L'utilisateur est seul responsable :
- des informations fournies,
- de la confidentialité de ses identifiants,
- de toute utilisation du service effectuée via son compte.
Le compte est strictement personnel et non transférable. Tout partage ou usage non autorisé est interdit.
L'éditeur ne saurait être tenu responsable des accès non autorisés résultant d'une négligence de l'utilisateur.

5. Description du service
Leadsme propose notamment les fonctionnalités suivantes :
- gestion de comptes utilisateurs,
- gestion de contacts et prospects,
- gestion de projets et livrables,
- dépôt de fichiers liés aux projets,
- outil de suivi des paiements à titre informatif,
- gestion des abonnements,
- envoi d'emails transactionnels,
- support via formulaire ou email.
Le service peut évoluer à tout moment. L'éditeur se réserve le droit de modifier, ajouter ou supprimer certaines fonctionnalités, sans obligation de maintien à l'identique du service.

6. Utilisation du service
L'utilisateur s'engage à utiliser le service :
- dans un cadre professionnel licite,
- conformément aux lois et réglementations en vigueur,
- conformément à la finalité du service.
L'utilisateur demeure seul responsable :
- des données qu'il saisit,
- du contenu qu'il héberge,
- des décisions prises à partir des informations fournies par le service.
Le service ne garantit ni résultats commerciaux, ni performance, ni exactitude ou pertinence des données manipulées.
Le service peut inclure des outils d'aide à la gestion, notamment un outil de suivi des paiements, fournis à titre strictement informatif et sur la base des informations saisies par l'utilisateur.
Ces outils ne constituent ni des outils comptables, ni fiscaux, ni juridiques, et ne se substituent en aucun cas aux obligations légales de l'utilisateur.

7. Fichiers et contenus hébergés
L'utilisateur peut déposer des fichiers liés à ses projets (ex. : briefs, devis, factures, livrables).
L'utilisateur garantit disposer de l'ensemble des droits nécessaires sur les fichiers déposés.
L'éditeur :
- n'exerce aucun contrôle a priori sur les contenus,
- n'est pas responsable du contenu hébergé par les utilisateurs.
Le service n'a pas vocation à constituer une solution de stockage ou d'archivage à long terme. Il appartient à l'utilisateur de conserver ses propres copies des fichiers.

8. Abonnements, offres et paiements
L'accès à certaines fonctionnalités du service peut nécessiter la souscription à un abonnement payant.
Une version gratuite et un essai gratuit de certaines offres peuvent être proposés selon les modalités indiquées sur le site.
L'essai gratuit est d'une durée de quatorze (14) jours et est limité à une seule utilisation par utilisateur.
L'utilisateur s'engage à respecter les quotas, limites et conditions applicables à l'offre ou au plan souscrit, tels que définis sur le site ou dans le service.
Les abonnements sont renouvelés automatiquement selon la périodicité choisie, sauf résiliation par l'utilisateur.
Les paiements liés aux abonnements sont traités exclusivement par un prestataire de paiement tiers. L'éditeur n'a jamais accès aux données bancaires des utilisateurs.
L'éditeur se réserve le droit de faire évoluer les tarifs des abonnements.
Toute modification tarifaire est portée à la connaissance de l'utilisateur avant son entrée en vigueur et s'applique aux périodes d'abonnement ultérieures.
L'utilisateur conserve la faculté de résilier son abonnement avant l'application des nouveaux tarifs.

9. Résiliation
L'utilisateur peut résilier son abonnement à tout moment selon les modalités mises à disposition dans son espace utilisateur ou via les outils de gestion fournis par le prestataire de paiement.
L'éditeur se réserve le droit de suspendre ou résilier un compte, sans indemnité, en cas de :
- non-respect des CGVU,
- usage abusif ou illicite du service,
- atteinte à la sécurité ou à l'intégrité du service.
En cas de manquement grave, la résiliation peut intervenir sans préavis.

10. Suppression des données
En cas de résiliation ou sur demande de l'utilisateur, les données peuvent être supprimées par l'éditeur dans un délai raisonnable, sous réserve des obligations légales ou techniques applicables.
La suppression de certaines données peut nécessiter une demande auprès du support.

11. Support
Un support est proposé via formulaire de contact ou email. L'utilisateur s'engage à un usage raisonnable et non abusif du support.
Les délais de réponse peuvent varier. Aucun niveau de service (SLA) n'est garanti.

12. Sécurité
L'éditeur met en œuvre des mesures de sécurité raisonnables afin de protéger le service et les données. L'utilisateur s'engage à ne pas porter atteinte à la sécurité du service.
Aucune garantie de sécurité absolue n'est fournie.

13. Responsabilité
L'éditeur ne saurait être tenu responsable :
- des dommages indirects,
- des pertes de données imputables à l'utilisateur,
- des conséquences liées à l'utilisation du service.
La responsabilité de l'éditeur est limitée aux dommages directs prouvés, dans les limites prévues par la loi.

14. Propriété intellectuelle
Le service, ses éléments, interfaces, marques et contenus sont protégés par le droit de la propriété intellectuelle.
Toute reproduction, exploitation ou utilisation non autorisée est interdite.

15. Données personnelles
Les traitements de données personnelles sont décrits dans la politique de confidentialité accessible sur le site.

16. Évolution et arrêt du service
L'éditeur se réserve le droit de faire évoluer ou d'arrêter le service, sous réserve d'un préavis raisonnable.
En cas d'arrêt définitif du service, les abonnements annuels en cours pourront être remboursés au prorata de la période non utilisée.

17. Cession
En cas de cession, transmission ou rachat du service, les présentes CGVU demeureront applicables, sous réserve d'information des utilisateurs.

18. Modification des CGVU
L'éditeur se réserve le droit de modifier les CGVU à tout moment. Les nouvelles versions s'appliquent dès leur mise en ligne.
L'utilisation continue du service vaut acceptation des CGVU modifiées.

19. Droit applicable et juridiction compétente
Les présentes CGVU sont régies par le droit français.
Tout litige relèvera de la compétence des tribunaux français.`,
  lastUpdate: "9 janvier 2026",
} as const;